function OrderCard({ order, onStatusChange }) {
    return (
      <div
        style={{
          border: '1px solid #ddd',
          padding: '12px',
          marginBottom: '12px',
          borderRadius: '6px',
        }}
      >
        <h3>Order #{order.orderNumber}</h3>
        <p>Customer: {order.customerName}</p>
        <p>Table: {order.tableNumber}</p>
        <p>Total: ₹{order.totalAmount}</p>
  
        <select
          value={order.status}
          onChange={e =>
            onStatusChange(order._id, e.target.value)
          }
        >
          <option>Pending</option>
          <option>Preparing</option>
          <option>Ready</option>
          <option>Delivered</option>
          <option>Cancelled</option>
        </select>
      </div>
    )
  }
  
  export default OrderCard
  